var RecentlyViewed = new (function () {
  const limit = 10;
  const useSessions = true;
  const storageKey = 'recently-viewed';
  const storage = localStorage.getItem(storageKey);
  const selectors = {
    productJson: '#productJson',
    productCard: '.product-card',
    recentlyViewedDest: '[data-recently-viewed-placeholder]',
  };

  /**
   * Add product to JS localStorage if visiting PDP.
   *
   * @returns void
   */
  function collectItem() {
    const productJson = document.querySelector(selectors.productJson);
    if (!productJson) return;

    const productData = JSON.parse(productJson.innerHTML);
    // console.log(productData)
    if (productData.tags.findIndex((el) => el == 'wholesale') > -1) return;
    const newItem = {
      id: productData.id,
      handle: productData.handle,
    };
    addRecentlyViewedToStorage(newItem);
  }

  /**
   * Place items that are kept in localStorage
   *
   * @returns void
   */
  function placeItems() {
    if (storage == null) {
      hideSections();
      return;
    }

    const currentProductJson = document.querySelector(selectors.productJson);
    let currentProductHandle = null;
    if (currentProductJson) {
      const currentProduct = JSON.parse(currentProductJson.innerHTML);
      currentProductHandle = currentProduct.handle;
    }

    const recentlyViewedItems = JSON.parse(storage);
    const productHandles = recentlyViewedItems
      .map(function (rc) {
        return rc.handle;
      })
      .filter(function (handle) {
        return handle != currentProductHandle;
      });

    Promise.all(productHandles.map((handle) => fetchData(handle)))
      .then((slides) => {
        const destination = document.querySelector(selectors.recentlyViewedDest);
        if (!destination || slides.length < 1) return;
        if (slides.length < 1) {
          hideSections();
          return;
        }

        slides = slides.filter((slide) => slide != null && slide != '[object HTMLDivElement]');
        // console.log('sliders', slides);

        destination.innerHTML = slides.join('');

        initSlider();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function initSlider() {
    // console.log('init slider');
    $('.recently-viewed-product-list')
      .slick({
        slidesToShow: 4,
        infinite: false,
        prevArrow: `.recently-viewed-product-list__navigation-buttons .slider-button--prev`,
        nextArrow: `.recently-viewed-product-list__navigation-buttons .slider-button--next`,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: true,
              // centerMode: true,
              // centerPadding: '60px',
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 500,
            settings: {
              arrows: true,
              // centerMode: true,
              // centerPadding: '60px',
              slidesToShow: 1,
            },
          },
        ],
      })
      .on('afterChange', function () {
        $(window).scroll();
      });
  }

  function hideSections() {
    const recentlyViewed = document.querySelectorAll('.recently-viewed');
    if (!recentlyViewed || recentlyViewed.length < 1) return;
    recentlyViewed.forEach((rv) => {
      rv.classList.add('hidden');
    });
  }

  function fetchData(handle) {
    const sessionCardSlide = sessionStorage.getItem(handle);
    if (sessionCardSlide == '[object HTMLDivElement]') {
      return getDataFromShopifyUrl(handle);
    }

    if (useSessions == true && sessionCardSlide != null) {
      // console.log('%cFetched from session', 'color:green');
      return new Promise((resolve) => {
        resolve(sessionCardSlide);
      });
    }

    return getDataFromShopifyUrl(handle);
  }

  function getDataFromShopifyUrl(handle) {
    return new Promise((resolve, reject) => {
      fetch(getProductCardUrl(handle))
        .then((response) => response.text())
        .then((data) => {
          const parser = new DOMParser();
          const dom = parser.parseFromString(data, 'text/html');
          const card = dom.querySelector(selectors.productCard);
          if (!card) resolve(null);

          const cardSlide = buildCardSlide(card);

          /** saving to session storage */
          // sessionStorage.setItem(handle, cardSlide);

          resolve(cardSlide);
        })
        .catch((e) => {
          reject(e);
        });
    });
  }

  function buildCardSlide(card) {
    const slide = document.createElement('div');
    // slide.classList.add("swiper-slide", "slider__slide");
    slide.innerHTML = card.innerHTML;

    // console.log(card.innerHTML);

    return card.innerHTML;
  }

  function getProductCardUrl(handle) {
    return `/products/${handle}?view=card`;
  }

  function addEventListeners() {
    document.addEventListener('DOMContentLoaded', function () {
      collectItem();
      placeItems();
    });
  }

  function getRecentlyViewedFromStrorage(newItem) {
    let recentlyViewed = [];
    if (typeof storage == 'string') {
      recentlyViewed = JSON.parse(storage);
    }

    return recentlyViewed.filter((rv) => rv.id != newItem.id);
  }

  function addRecentlyViewedToStorage(newItem) {
    const recentlyViewed = getRecentlyViewedFromStrorage(newItem);

    const newRecentlyViewed = [newItem, ...recentlyViewed].slice(0, limit);

    //console.log('recently viewed: ', newRecentlyViewed);

    const stringifiedObj = JSON.stringify(newRecentlyViewed);
    if (stringifiedObj == '[object HTMLDivElement]' || stringifiedObj == null) return;

    localStorage.setItem(storageKey, JSON.stringify(newRecentlyViewed));
  }

  addEventListeners();

  return {
    collectItem: collectItem,
    placeItems: placeItems,
  };
})();
